<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :visible.sync="addMemberDialogVisible"
               class="custom_form_dialog custom-form-dialog personnel_form_dialog"
               title="新增员工"
               width="560px">
        <div class="custom_form_body">
            <CustomFormPc v-if="dataLoaded"
                          ref="customFormPc"
                          :field_list="formInfoList"
                          :is_form_module="true"
                          @submit-form="summitFormData"/>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm">保存</el-button>
        </span>
    </el-dialog>
</template>
<script>
    import CustomFormPc from "@/components/pComponents/CustomFormPc";
    import {addUser, getFormFields} from "@/api";

    export default {
        name: "addMember",
        props: {
            addMemberDialogVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                addMemberFormData: {},
                loading: false,
                formInfoList: [],
                dataLoaded: false,
            };
        },
        components: {CustomFormPc},
        created() {
            this._getFromFields()
        },
        methods: {
            _getFromFields() {
                this.loading = true
                getFormFields({
                    field_form: 'users'
                }).then(res => {
                    if (res.code === 200) {
                        this.formInfoList = res.data
                        this.dataLoaded = true
                    } else {
                        this.$message.error(res.message)
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },

            handleDialogClose() {
                this.$emit('update:addMemberDialogVisible', false)
            },

            handleDialogConfirm() {
                this.$refs.customFormPc.handleClickPublish()
            },

            summitFormData(customForm) {
                addUser(customForm).then(res => {
                    if (res.code === 200) {
                        this.$emit('update:addMemberDialogVisible', false)
                        this.$message.success('新增成功')
                        this.$emit('success-callback')
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
    };
</script>
<style lang="scss" scoped>

</style>
